/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface HubsHubKioskGetPrinterStatusPost$Params {
  kioskId?: number;
}

export function hubsHubKioskGetPrinterStatusPost(http: HttpClient, rootUrl: string, params?: HubsHubKioskGetPrinterStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, hubsHubKioskGetPrinterStatusPost.PATH, 'post');
  if (params) {
    rb.query('kioskId', params.kioskId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

hubsHubKioskGetPrinterStatusPost.PATH = '/hubs/HubKiosk/GetPrinterStatus';
